module.exports = __webpack_public_path__ + "panel_log_51all-small.jpg";